export { RegisterStudentAnonymouslyMutation } from './register-student-anonymously';
